import { formatSnakeCase } from './impactLabel'

const DIFFERENCE_TYPE_LABELS: Record<string, string> = {
  ie_cobra_enrollment: 'Mismatched COBRA enrollment',
  preferred_contact_method: 'Mismatched preferred contact method',
  custom_identifiers: 'Mismatched custom identifier',
  dob: 'Mismatched date of birth',
  dependent_relationship: 'Mismatched dependent relationship',
  ie_effective_end_date: 'Mismatched effective end date',
  ie_effective_start_date: 'Mismatched effective start date',
  email_address: 'Mismatched email',
  employment_status: 'Mismatched employment status',
  ie_config: 'Mismatched enrollment config',
  ie_enroll_data: 'Mismatched enrollment data',
  ie_status: 'Mismatched enrollment status',
  full_name: 'Mismatched name',
  full_time_start: 'Mismatched full-time start date',
  hire_date: 'Mismatched hire date',
  home_phone: 'Mismatched home phone',
  employment_hours_worked: 'Mismatched hours worked',
  ie_individual_type: 'Mismatched individual type',
  mailing_address: 'Mismatched mailing address',
  marital_status: 'Mismatched marital status',
  military: 'Mismatched military information',
  missing_ie: 'Missing enrollment',
  missing_member: 'Missing member',
  employment_occupation: 'Mismatched occupation',
  home_address: 'Mismatched home address',
  preferred_language: 'Mismatched preferred language',
  rehire_date: 'Mismatched rehire date',
  salary: 'Mismatched salary',
  sex: 'Mismatched sex',
  ssn: 'Mismatched SSN',
  student: 'Mismatched student status',
  termination_date: 'Mismatched termination date',
  unavailable_employee: 'Employee unavailable at carrier',
  work_phone: 'Mismatched work phone',
  work_state: 'Mismatched work state',
}

export function differenceTypeLabel(differenceType: string): string {
  const label = DIFFERENCE_TYPE_LABELS[differenceType]
  if (typeof label === 'string') {
    return label
  }
  return formatSnakeCase(differenceType)
}
